<template>
  <div :class='type == "scan" ? "":"s_bf p-24"' style="padding-top: 0;">
    <a-tabs>
      <a-tab-pane key="1" tab="扫码人信息">
        <a-descriptions class="m-t-20" bordered :column='3' layout="vertical">
          <a-descriptions-item label="领奖用户">{{user.clerk_name}}</a-descriptions-item>
          <a-descriptions-item label="微信昵称">{{user.member_name}}</a-descriptions-item>
          <a-descriptions-item label="手机号">{{user.clerk_phone}}</a-descriptions-item>
          <a-descriptions-item label="角色">{{user.clerk_type_text}}</a-descriptions-item>
          <a-descriptions-item v-if="typename=='store'" label="所属门店">{{user.store_name || '-'}}</a-descriptions-item>
          <a-descriptions-item v-if="typename=='distributor'" label="所属经销商">{{user.dealer_name || '-'}}</a-descriptions-item>
          <a-descriptions-item v-if="typename=='store'" label="门店所属上级">{{user.distributor_name || '-'}}</a-descriptions-item>
        </a-descriptions>
      </a-tab-pane>
      <a-tab-pane key="2" tab="码信息">
        <a-descriptions class="m-t-20" bordered :column='3' layout="vertical">
          <!-- <a-descriptions-item label="码段">{{code.code_sn}}</a-descriptions-item> -->
          <a-descriptions-item label="批次">{{code.batch_sn}}</a-descriptions-item>
          <a-descriptions-item label="防伪码">{{code.fwcode_sn || '-'}}</a-descriptions-item>
          <a-descriptions-item label="流水号">{{code.code_sn}}</a-descriptions-item>
          <a-descriptions-item label="商品批次">{{code.product_batch_name}}</a-descriptions-item>
          <a-descriptions-item label="商品ID">{{code.product_id}}</a-descriptions-item>
          <a-descriptions-item label="商品名称">{{code.product_name}}</a-descriptions-item>
          <a-descriptions-item label="扫码地区">{{code.scan_area || '-'}}</a-descriptions-item>
          <a-descriptions-item v-if="typename=='store'" label="二维码终端门店">{{code.store_name || '-'}}</a-descriptions-item>
          <a-descriptions-item v-if="typename=='distributor'" label="二维码终端门店">{{code.store_name || '-'}}</a-descriptions-item>
          <!-- <a-descriptions-item label="详细地址">{{code.area || '-'}}</a-descriptions-item>
          <a-descriptions-item label="经纬度">
            <span v-if='code.latitude'>{{code.latitude}}，{{code.longitude}}</span>
            <span v-else>-</span>
          </a-descriptions-item> -->
        </a-descriptions>
      </a-tab-pane>
      <a-tab-pane key="3" tab="活动信息">
        <a-descriptions class="m-t-20" bordered :column='3' layout="vertical">
          <a-descriptions-item label="活动ID">{{activity.activity_id || '-'}}</a-descriptions-item>
          <a-descriptions-item label="活动名称">{{activity.activity_name || '-'}}</a-descriptions-item>
          <a-descriptions-item label="活动备注">{{activity.activity_remarks || '-'}}</a-descriptions-item>
          <a-descriptions-item label="中奖时间">{{activity.award_time || '-'}}</a-descriptions-item>
          <a-descriptions-item label="发放状态">{{activity.award_status_title || '-'}}</a-descriptions-item>
        </a-descriptions>
        <a-table v-if="type=='activity'" :pagination='false' :loading='listLoading' bordered :columns='exacolumns' :data-source='exadata'>
          <template v-slot:action="{  }">
             <a href="javascript:;" v-has:guideAwardLogsExamine="()=>{showMoreExa = true;}" class="m-l-10">查看</a>
          </template>
        </a-table>
        <p class="m-t-20 m-b-20 fz-16 ">奖项内容：</p>
        <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='data'></a-table>
      </a-tab-pane>
    </a-tabs>
  </div>
     <a-modal :keyboard="false" title="审核信息" centered v-model:visible="showMoreExa" :width='1000' :footer="null" destroyOnClose>
     <examine :typename="typename=='store'?'store':'distributor'" :id='id' @showclose='showclose' typeexa='look'></examine>
   </a-modal>
</template>

<script>
import { ref, onMounted, reactive, toRefs, inject } from "vue";
import {
  getGuideAwardMore,
  getGuideAwardDetail,
  getdealer_scan_awardDetail,
  getdealer_scanAwardMore,
} from "@/api/guide";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import examine from '../awardLogs/examine.vue'
export default {
  props: {
    type: String,
    id: Number || String,
    typename: String,
    scanname: String,
  },
      components: { examine},
  setup(props) {
    const state = reactive({
      listLoading: true,
      activity: {},
      code: {},
      user: {},
      data: [],
      type: "scan",
      id: 0,
      exadata: [{
        scan_award_permit_status_text:'',
        award_fail_reason:'',
      }],
      showMoreExa:false,
    });
    let exacolumns = [
      {
        title: "审核状态",
        dataIndex: "scan_award_permit_status_text",
        key: "scan_award_permit_status_text",
      },
      {
        title: "审核备注",
        dataIndex: "award_fail_reason",
        key: "award_fail_reason",
           customRender: ({ record }) => {
            return record.award_fail_reason ? record.award_fail_reason : '-'
          }
      },
      {
        title: "审核详情",
        dataIndex: "action",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
    let columns = [
      {
        title: "奖项内容",
        dataIndex: "award_name",
        key: "award_name",
      },
      {
        title: "发放状态",
        dataIndex: "award_status_title",
        key: "award_status_title",
      },
      {
        title: "备注",
        dataIndex: "remarks",
        key: "remarks",
      },
    ];
    const $route = inject("$route");
    const $router = inject("$router");
    const _lodash = inject("_lodash");
    const getMore = async () => {
      const hide = message.loading("正在加载中...", 0);
      let res;
      if (state.type == "scan") {
        if (props.scanname == "store") {
          res = await getGuideAwardMore(state.id).then((res) => res.data);
        } else {
          res = await getdealer_scanAwardMore(state.id).then((res) => res.data);
        }
      } else {
        if (props.typename == "store") {
          res = await getGuideAwardDetail(state.id).then((res) => res.data);
        } else {
          res = await getdealer_scan_awardDetail(state.id).then(
            (res) => res.data
          );
        }
      }
      state.listLoading = false;
      setTimeout(hide);
      if (iscode(res)) {
        console.log(res);
        state.activity = res.data.activity_info;
        state.exadata[0].scan_award_permit_status_text=res.data.activity_info.scan_award_permit_status_text;
        state.exadata[0].award_fail_reason=res.data.activity_info.award_fail_reason;
        state.code = res.data.code_info;
        state.user = res.data.user_info;
        state.data = res.data.award_list;
      } else {
        message.error(res.msg);
      }
    };
        const showclose = (data) => {
     state.showMoreExa=data;
    };
    onMounted(() => {
      state.type = props.type;
      state.id = props.id;
      getMore();
    });
    return {
      ...toRefs(state),
      columns,
      exacolumns,
      showclose
    };
  },
};
</script>